import React, { useMemo } from 'react';

import Link from 'next/link';
import { RiArrowRightSLine } from 'react-icons/ri';

import { INavigationProps } from 'store/modules/product';

import * as S from './styles';

interface INavigationPagesProps {
  navigationPages: Array<INavigationProps>;
}

const NavigationPages: React.FC<INavigationPagesProps> = ({
  navigationPages,
}) => {
  const navigationProps = useMemo(() => {
    return navigationPages.map(item => {
      if (!!item.permalink && item.permalink.match('path=')) {
        return {
          ...item,
          permalink: item.permalink.split('path=')[1].split('/')[1],
        };
      }
      return item;
    });
  }, [navigationPages]);

  return (
    <S.Container className="navigation-pages">
      {navigationProps.map((item, index) => (
        <li key={`${item.id} - ${item.nome}`}>
          {index !== 0 && <RiArrowRightSLine />}
          <Link href={item.permalink || '/'}>
            <a href={item.permalink || '/'} title={item.nome}>
              {item.nome}
            </a>
          </Link>
        </li>
      ))}
    </S.Container>
  );
};

export default NavigationPages;
